import React from 'react';
import { CheckCircle2, Circle, Loader2 } from 'lucide-react';

const STAGES = [
  { key: 'submitted', label: 'Submitted' },
  { key: 'reviewed', label: 'Reviewed' },
  { key: 'approved', label: 'Approved' },
  { key: 'whatsapp_generated', label: 'WhatsApp' },
  { key: 'radio_generated', label: 'Radio' },
  { key: 'social_generated', label: 'Social' },
  { key: 'video_generated', label: 'Video' },
  { key: 'policy_generated', label: 'Policy' },
  { key: 'evidence_generated', label: 'Evidence' },
];

export const PipelineVisual = ({ pipeline, generationStatus }) => {
  const p = pipeline || {};
  const generating = generationStatus === 'running';
  return (
    <div className="flex flex-wrap items-center gap-1" data-testid="pipeline-visual">
      {STAGES.map((stage, idx) => {
        const done = !!p[stage.key];
        const isLast = idx === STAGES.length - 1;
        const isGenStage = idx >= 3;
        const showSpinner = isGenStage && !done && generating;
        return (
          <React.Fragment key={stage.key}>
            <div
              data-testid={`pipeline-stage-${stage.key}`}
              className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium transition ${
                done
                  ? 'bg-[#07743F] text-white'
                  : showSpinner
                  ? 'bg-[#E4E517]/40 text-gray-700'
                  : 'bg-gray-100 text-gray-500'
              }`}
              title={stage.label}
            >
              {done ? (
                <CheckCircle2 className="w-3 h-3" />
              ) : showSpinner ? (
                <Loader2 className="w-3 h-3 animate-spin" />
              ) : (
                <Circle className="w-3 h-3" />
              )}
              <span>{stage.label}</span>
            </div>
            {!isLast && (
              <span className={`w-2 h-0.5 ${done ? 'bg-[#07743F]' : 'bg-gray-200'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PipelineVisual;
